import Tasks from 'APP/Tasks';

import prepareImageUrls from '../../../../../services/prepareImageUrls';

// Needs Bff implementation
// async function request(data) {
//   try {
//     const { url, graphicSize } = {};
//
//     return {
//       url,
//       graphicSize,
//     };
//   } catch (error) {
//     console.error(error);
//   }
//
//   return {
//     url: null,
//     graphicSize: null,
//   };
// }

export default async () => {
  const { url, graphicSize } = {};

  if (!url || !graphicSize) {
    return {
      url,
      graphicSize,
    };
  }

  const { imageUrl, blurredImageUrl } = prepareImageUrls(url);

  try {
    await Promise.all([Tasks.app.preloadImage(imageUrl), Tasks.app.preloadImage(blurredImageUrl)]);

    return {
      url,
      graphicSize,
    };
  } catch {
    return {
      url: null,
      graphicSize: null,
    };
  }
};
